export default __webpack_public_path__ + "static/media/white_menu.8df07c3b.svg";